export const DEFAULT_INITIAL_VALUES = {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
};

export const expandedConfig = {
    JP: {
        dateOfBirth: null,
        phoneticFirstName: null,
        phoneticLastName: null,
    },
};
